import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const useUserFormValidation = (values, options = {}) => {
  const { t } = useTranslation();
  const [errors, setErrors] = useState({});

  const {
    requireEmail = true,
    requireEstablishment = true,
    requireRole = true,
  } = options;

  const validateForm = useCallback(() => {
    const newErrors = {};
    const email = values?.email?.trim() || "";
    const emailLabel = t("manageUsers.columns.mail");
    const establishmentLabel = t("manageUsers.columns.establishment");
    const roleLabel = t("manageUsers.columns.role");

    if (requireEmail) {
      if (!email) {
        newErrors.email = t("commons.errors.requiredField", {
          fieldName: emailLabel,
        });
      } else if (!EMAIL_REGEX.test(email)) {
        newErrors.email = t("commons.errors.invalidEmail", {
          fieldName: emailLabel,
        });
      }
    } else if (email && !EMAIL_REGEX.test(email)) {
      newErrors.email = t("commons.errors.invalidEmail", {
        fieldName: emailLabel,
      });
    }

    if (requireEstablishment && !values?.establishment) {
      newErrors.establishment = t("commons.errors.requiredField", {
        fieldName: establishmentLabel,
      });
    }

    if (requireRole && !values?.role) {
      newErrors.role = t("commons.errors.requiredField", {
        fieldName: roleLabel,
      });
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }, [requireEmail, requireEstablishment, requireRole, t, values]);

  const clearErrors = useCallback(() => {
    setErrors({});
  }, []);

  return { errors, validateForm, clearErrors };
};
